import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Service from "../../../../services/workbooks";
import TrainingService from "../../../../services/trainings/TrainingsService";
import Modal from "../../../../constants/Modal";
import Weekday from "../../../../common/Weekday";
import { Training } from "../../../../types/types";

type Props = {
    workbook_id: number;
    onRefresh: () => void;
    t: any;
};

type State = {
    trainings: Training[];
    selectedTrainingId: number | null;
    showModal: boolean;
};

class CopyTraining extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            trainings: [],
            selectedTrainingId: null,
            showModal: false,
        };
    }

    componentDidMount() {
        this.loadTrainings();
    }

    loadTrainings = async () => {
        try {
            const response = await Service.getTrainings(this.props.workbook_id);
            this.setState({ trainings: response.data });
        } catch (error) {
            console.error("Błąd przy pobieraniu treningów:", error);
        }
    };

    toggleModal = () => {
        this.setState((prevState) => ({ showModal: !prevState.showModal }));
    };

    handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ selectedTrainingId: Number(e.target.value) });
    };

    handleCopy = async () => {
        const { selectedTrainingId } = this.state;
        const { onRefresh } = this.props;

        if (!selectedTrainingId) return;

        try {
            await TrainingService.copyTraining(selectedTrainingId);
            this.toggleModal();
            onRefresh();
        } catch (error) {
            console.error("Błąd podczas kopiowania treningu:", error);
        }
    };

    render() {
        const { t } = this.props;
        const { trainings, selectedTrainingId, showModal } = this.state;

        return (
            <div style={{ margin: "1em 0" }}>
                <button onClick={this.toggleModal}>
                    {t("buttons.copy_training")}
                </button>

                <Modal
                    show={showModal}
                    onClose={this.toggleModal}
                    title={t("buttons.copy_training")}
                >
                    <div className="center">
                        <select
                            onChange={this.handleSelectChange}
                            value={selectedTrainingId || ""}
                            style={{ marginBottom: "1em", padding: "0.5em", width: "100%" }}
                        >
                            <option value="" disabled>
                                {t("workbooks.select_training_to_copy")}
                            </option>
                            {trainings.map((training) => (
                                <option key={training.id} value={training.id}>                                
                                    <Weekday date={new Date(training.date).toISOString().slice(0, 10)} />
                                    {/* {training.notes || t("workbooks.no_notes")} */}
                                </option>
                            ))}
                        </select>

                        <button
                            onClick={this.handleCopy}
                            disabled={!selectedTrainingId}
                            className="field"
                        >
                            {t("buttons.copy")}
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("global")(CopyTraining);
